import { render, staticRenderFns } from "./OrganismTitleTextImage.vue?vue&type=template&id=c373cf7e&"
import script from "./OrganismTitleTextImage.vue?vue&type=script&lang=js&"
export * from "./OrganismTitleTextImage.vue?vue&type=script&lang=js&"
import style0 from "./OrganismTitleTextImage.vue?vue&type=style&index=0&id=c373cf7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default})
